import api from './axiosInstance';
import i18n from '../i18n';


export const getDashboard = async (userId, startDate, endDate, platformIds, clickId) => {
    try {
        const response = await api.post(`/dashboard/${userId}`, {
            startDate,
            endDate,
            platformIds: platformIds || null,
            clickId: clickId || null,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        throw new Error(i18n.t('dashboardService.load_dashboard_error'));
    }
};